module.exports = __webpack_public_path__ + "img/painPerceptionScale_10_w.c4a6d041.png";